import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';

/** Square app tiles, centred, two up on a phone and three from sm. */
export function AppGrid({ children }: { children: ReactNode }) {
  return <div className="apps-grid">{children}</div>;
}

/**
 * An icon over a name. `external` opens `to` in a new tab instead of routing
 * inside the SPA.
 */
export function AppCard({
  to,
  external,
  icon,
  title,
}: {
  to: string;
  external?: boolean;
  icon: ReactNode;
  title: string;
}) {
  const content = (
    <>
      {icon}
      <span className="app-card-title">{title}</span>
    </>
  );
  if (external)
    return (
      <a
        href={to}
        target="_blank"
        rel="noopener noreferrer"
        className="app-card"
      >
        {content}
      </a>
    );
  return (
    <Link to={to} className="app-card">
      {content}
    </Link>
  );
}

/**
 * A smaller card with `actions` overlaid on its corner, shown on hover or
 * focus.
 */
export function AppCardSlot({
  id,
  actions,
  children,
}: {
  id?: string;
  actions: ReactNode;
  children: ReactNode;
}) {
  return (
    <div id={id} className="app-card-slot">
      {children}
      <div className="app-card-actions">{actions}</div>
    </div>
  );
}
